'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import classNames from 'classnames';
import H3 from 'UIComponents/elements/headings/H3';
import UICardSection from 'UIComponents/card/UICardSection';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import UIList from 'UIComponents/list/UIList';

const GeneralInfoCardList = ({
  children,
  listCategoryKey,
  listClassNames,
  toolTip,
  styled = false,
  expandable = false
}) => {
  const renderedList = useMemo(() => {
    return children ? /*#__PURE__*/_jsxs(UICardSection, {
      className: "p-x-0 p-top-0 " + (expandable ? 'p-bottom-0' : 'p-bottom-7'),
      children: [/*#__PURE__*/_jsx(H3, {
        className: "is--heading-5 m-bottom-2 display-inline",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `ecosystem-marketplace-solutions-ui.profile.general.${listCategoryKey}`
        })
      }), toolTip && toolTip, /*#__PURE__*/_jsx(UIList, {
        className: classNames('m-bottom-0', listClassNames),
        styled: styled,
        children: children
      })]
    }) : null;
  }, [children, expandable, listCategoryKey, listClassNames, styled, toolTip]);
  return expandable ? /*#__PURE__*/_jsx(UICardSection, {
    className: "p-x-0 p-top-0 p-bottom-4",
    children: /*#__PURE__*/_jsx(UIExpandableText, {
      buttonAlign: "left",
      hideButtonCaret: true,
      maxHeight: 144,
      children: renderedList
    })
  }) : renderedList;
};

GeneralInfoCardList.propTypes = {
  children: PropTypes.node,
  listCategoryKey: PropTypes.string.isRequired,
  listClassNames: PropTypes.string,
  toolTip: PropTypes.element,
  styled: PropTypes.bool,
  expandable: PropTypes.bool
};
export default GeneralInfoCardList;